import styled from "styled-components";

export const StageListContainer = styled.div``;